module.exports = __webpack_public_path__ + "img/ocho-logo2.f854ba3f.png";